import "./NewsCard.scss";
import LinkWithArrow from "../../Atoms/LinkWithArrow/LinkWithArrow";
import ReactMarkdown from "react-markdown";
import capitalizedFirstLetter from "../../../Services/capitalizedFirstLetter";

const NewsCard = ({
	image,
	date,
	title,
	content,
	linkRoute,
	linkText,
	inPostulaciones,
	post,
}) => {
	return (
		<div className="newsCard-container grid fullColumn mt-20 mb-20 ">
			<div
				className={`newsCard-top-image-container ${
					inPostulaciones && "in-postulaciones"
				}`}
			>
				<img
					src={post ? post.multimedia[0].url : image}
					alt="News"
					className={`${
						!inPostulaciones
							? "newsCard--img news"
							: "newsCard--img postulaciones"
					} `}
				/>
			</div>
			<div className="newsCard-content-container pr-25 pl-25 ">
				<h5 className="t5 c-yellow no-space">{date}</h5>
				<h4 className="t4">
					{post ? capitalizedFirstLetter(post.titulo_esp) : title}
				</h4>
				{post && (
					<div className="newsCard--markdown-container">
						<ReactMarkdown>{post.contenido_esp}</ReactMarkdown>
					</div>
				)}
				{!post && <p className="body-16">{content}</p>}
			</div>
			<div className="newsCard-link-container pl-25 ">
				<LinkWithArrow
					linkRoute={linkRoute}
					linkText={linkText}
					data={post}
				/>
			</div>
		</div>
	);
};

export default NewsCard;
